<template>
  <div class="stage" :class="{ cleared: isTableClear(table.name) }">
    <a href="#" @click.stop.prevent="doSelect" :class="[addtionalStarClass]">
      <img v-if="clearLevel == 0" class="star" :src="$image(starImageLv0)" alt="" />
      <img v-else-if="clearLevel == 1" class="star" :src="$image(starImageLv1)" alt="" />
      <img v-else-if="clearLevel == 2" class="star" :src="$image(starImageLv2)" alt="" />
      <img :src="$image(buttonImage)" :alt="table.title + 'のだん'" />
    </a>
  </div>
</template>

<script>
import Bonus from "@/mixins/bonus";

export default {
  mixins: [Bonus],
  props: {
    table: {
      type: Object,
      required: true,
    },
    starImageLv0: {
      type: String,
      required: true,
    },
    starImageLv1: {
      type: String,
      required: true,
    },
    starImageLv2: {
      type: String,
      required: true,
    },
    buttonImage: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    addtionalStarClass: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    clearLevel() {
      if (this.data.level2.clear > 0) {
        return 2;
      } else if (this.data.level1.clear > 0) {
        return 1;
      }

      return 0;
    },
  },
  methods: {
    // ステージ選択
    doSelect() {
      // 画面ボタン操作イベント
      this.$store.dispatch("history/viewButtonEvent", {
        loginId: this.$store.getters["auth/getLoginId"],
        view: this.$store.getters["app/getCurrentView"],
        event: this.table.title + "のだん選択",
      });
      // テーブル選択
      this.$store.dispatch("app/selectTable", this.table.name);
      // ビュー変更
      this.$store.commit("app/setCurrentView", this.table.view);
      // スタートガイド再生
      this.$sound.start(this.table.name).play();
    },
  },
};
</script>

<style lang="scss" scoped>
.stage {
  a {
    display: flex;
    flex-direction: column;
    align-items: center;

    .star {
      height: calc(var(--size-base) * 120);
      margin-bottom: 10%;
    }
  }
}
</style>